export const __STORAGE_COMPARE_KEYS__ = "CSR_PLP-COMPARE-KEYS";
export const __STORAGE_WISH_PRODUCTS__ = "CSR_WISH-PRODUCTS"; // 心愿单产品
export const __STORAGE_DELIVERY_CHECKER__= "DELIVERY_CHECKER"